module.exports = [
	{
		"name": "开放接口--物流",
		"children": [
			{
				"name": "wdwd.logistics.companies.get",
				"description": "获取物流公司代码和名称"
			},
			{
				"name": "wdwd.logistics.offline.send",
				"description": "发货"
			},
			{
				"name": "wdwd.logistics.offline.update",
				"description": "更改发货信息"
			}
		]
	},
	{
		"name": "开放接口--商品",
		"children": [
			{
				"name": "wdwd.product.quantity.update",
				"description": "商品/SKU库存修改"
			},
			{
				"name": "wdwd.skus.custom.get",
				"description": "根据外部 商品货号获取skus列表"
			}
		]
	},
	{
		"name": "开放接口--订单",
		"children": [
			{
				"name": "wdwd.trade.close",
				"description": "订单关闭"
			},
			{
				"name": "wdwd.trade.fullinfo.get",
				"description": "获取订单的详细信息"
			},
			{
				"name": "wdwd.trade.memo.update",
				"description": "更新备注"
			},
			{
				"name": "wdwd.trades.sold.get",
				"description": "订单列表"
			},
			{
				"name": "wdwd.trades.sold.increment.get",
				"description": "订单列表"
			}
		]
	},
	{
		"name": "开放接口--商品",
		"children": [
			{
				"name": "wdwd.item.quantity.update",
				"description": "SKU库存修改"
			},
			{
				"name": "wdwd.items.inventory.get",
				"description": "获取库存商品列表"
			},
			{
				"name": "wdwd.items.onsale.get",
				"description": "获取在售商品列表"
			}
		]
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./app/data/api/index.json
 ** module id = 523
 ** module chunks = 1
 **/